import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { DataService } from 'src/app/dashboard/_services/data.service';
import { BusStudentsService } from '../../_services/bus-students.service';
import { EnrollError } from '../enroll-error-interface';
import { environment } from 'src/environments/environment';
import { AutoUnsubscribe } from 'src/app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe
@Component({
  selector: 'app-enroll-details',
  templateUrl: './enroll-details.component.html',
  styleUrls: ['./enroll-details.component.scss']
})
export class EnrollDetailsComponent {
  enrollDetails: any;
  combinedSudentsArray: any[] = [];
  allStudents: any[] = [];
  successStudents: any[] = [];
  failStudents: any[] = [];
  destroy$ = new Subject<void>();
  currLang;
  baseUrl = environment.img_url;
  loading = true;
  activeTab: string = 'success';
  constructor(
    private dataService: DataService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private busesStudentsService: BusStudentsService,
    private _router: Router) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
    this.globalService.getLang().pipe(takeUntil(this.destroy$)).subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.busesStudentsService.getEnrollDetails().pipe(takeUntil(this.destroy$)).subscribe((res) => {
      if (!res || Object.keys(res).length === 0) {
        this.back(); // route back if response is empty
        return;
      }
      this.loading = true;
      this.enrollDetails = res;
      console.log('enrollDetails', this.enrollDetails);
      this.combinedSudentsArray = this.combineArrays(res?.subscribed_ids, res?.failed_ids);
      console.log('combinedSudentsArray', this.combinedSudentsArray);
      this.getStudentsByIds(this.combinedSudentsArray);
    })
  }

  combineArrays(arr1, arr2) {
    return [...arr1, ...arr2];
  }

  getStudentsByIds(ids) {
    let body: any = {}
    body.ids = ids;
    this.busesStudentsService.getStudentsByIds(body).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.allStudents = res;
      this.filterFailAndSuccess(this.allStudents);
      this.loading = false;
    }, (err) => { })
  }

  filterFailAndSuccess(allStudents) {
    this.successStudents = allStudents.filter(student =>
      this.enrollDetails?.subscribed_ids.includes(student?.id?.toString())
    );

    this.failStudents = allStudents.filter(student =>
      this.enrollDetails?.failed_ids.includes(student?.id?.toString())
    );
  }
  back() {
    this._router.navigateByUrl('/buses/students');
  }
  setActiveTab(tab: string): void {
    this.activeTab = tab;
  }
}
